import {Component, inject, OnInit, ViewChild} from '@angular/core';
import {CustomErrorComponent} from "../../../../shared/commons/custom-error.component";
import {FormsModule, NgForm} from "@angular/forms";
import {GtNgDatepickerModule} from "../../../../shared/commons/gt-ng-datepicker/gt-ng-datepicker.module";
import {NgIf, SlicePipe} from "@angular/common";
import {NotFoundComponent} from "../../../../shared/not-found/not-found.component";
import {NgbPagination} from "@ng-bootstrap/ng-bootstrap";
import {SharedCommonModule} from "../../../../shared/commons/shared-common.module";
import {ReportOnOffBoardResultDto} from "../../../../../generated-model/model";
import {ErmRegisterResource} from "../../../../service/ErmRegisterResource";
import {updateFormAndValidity} from "../../../../app.constants";
import {UcRegisterHistoryModalService} from "../uc-register-history-modal/uc-register-history-modal.service";
import {ThaiDateTimePipe} from "../../../../shared/commons/thai-datetime.pipe";

@Component({
  selector: 'app-uc-register-history',
  standalone: true,
  imports: [
    CustomErrorComponent,
    FormsModule,
    GtNgDatepickerModule,
    NgIf,
    NotFoundComponent,
    NgbPagination,
    SharedCommonModule,
    SlicePipe,
    ThaiDateTimePipe
  ],
  templateUrl: './uc-register-history.component.html',
  styleUrl: './uc-register-history.component.scss'
})
export class UcRegisterHistoryComponent implements OnInit {

  @ViewChild("form", {read: NgForm, static: true}) form: NgForm;
  personalId: string;
  ermRegisterResource = inject(ErmRegisterResource);
  ucRegisterHistoryModalService = inject(UcRegisterHistoryModalService);
  dataList: ReportOnOffBoardResultDto[] = [];
  page: number = 0;
  pageSize: number = 20;

  ngOnInit(): void {
  }

  search() {
    let formValid = updateFormAndValidity(this.form);
    if (formValid) {
      this.ermRegisterResource.searchReportOnOffBoard(this.personalId)
        .subscribe(value => {
          this.dataList = value;
          //order by date
          //i can't use sort in backend because query is union
          this.dataList.sort((a, b) => {
            return new Date(b.createDate).getTime() - new Date(a.createDate).getTime();
          });
        });
    }
  }

  showDetail(item: ReportOnOffBoardResultDto) {
    this.ucRegisterHistoryModalService.open(item);
  }
}
